import React from 'react';
import { Bot, FileText, Database, HelpCircle } from 'lucide-react';

interface AgentWelcomeProps {
  onSuggestedPrompt: (prompt: string) => void;
}

export const AgentWelcome: React.FC<AgentWelcomeProps> = ({ onSuggestedPrompt }) => {
  const suggestedPrompts = [
    {
      icon: Database,
      text: 'Quante checklist sono state compilate questo mese?',
      category: 'Statistiche'
    },
    {
      icon: FileText,
      text: 'Cosa dice il Regolamento IVASS sull\'adeguata verifica?',
      category: 'Normativa'
    },
    {
      icon: HelpCircle,
      text: 'Come si compila la sezione Parte A?',
      category: 'Guida'
    },
    {
      icon: Database,
      text: 'Mostrami le checklist IBIP recenti',
      category: 'Ricerca'
    }
  ];

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
      <div className="mb-6">
        <div className="w-20 h-20 rounded-full bg-indigo-100 flex items-center justify-center mx-auto mb-4">
          <Bot className="w-12 h-12 text-indigo-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Benvenuto nell'Assistente Checklist
        </h2>
        <p className="text-gray-600 max-w-md">
          Posso aiutarti a navigare le informazioni del database, rispondere a domande sulla normativa IVASS e guidarti nella compilazione delle checklist.
        </p>
      </div>

      <div className="w-full max-w-2xl">
        <p className="text-sm font-medium text-gray-700 mb-3">Prova a chiedere:</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {suggestedPrompts.map((prompt, index) => (
            <button
              key={index}
              onClick={() => onSuggestedPrompt(prompt.text)}
              className="flex items-start gap-3 p-4 border border-gray-200 rounded-lg hover:border-indigo-500 hover:bg-indigo-50 transition-colors text-left group"
            >
              <prompt.icon className="w-5 h-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <div className="text-xs text-gray-500 mb-1">{prompt.category}</div>
                <div className="text-sm text-gray-900 group-hover:text-indigo-900">
                  {prompt.text}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg max-w-2xl">
        <p className="text-sm text-blue-800">
          <strong>Nota:</strong> L'assistente è in modalità solo lettura. Può consultare i dati ma non modificarli.
          Tutte le risposte includono riferimenti alle fonti utilizzate.
        </p>
      </div>
    </div>
  );
};
